import { render, staticRenderFns } from "./RecipeManager.vue?vue&type=template&id=0d7c8815&scoped=true&"
import script from "./RecipeManager.script.js?vue&type=script&lang=js&"
export * from "./RecipeManager.script.js?vue&type=script&lang=js&"
import style0 from "./RecipeManager.scss?vue&type=style&index=0&id=0d7c8815&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7c8815",
  null
  
)

export default component.exports